import { PapiDeviation } from '@wix/da-papi-types';
import DeviationMediaService from '../DeviationMediaService';

/**
 * This used to lazyload the hero by using low-res and then upgrading,
 * however web vitals see many heros as the LCP element and lazy loading
 * that element leads to bad scores. We therefore prefer to load the full
 * image early.
 *
 * see useHeroImageForContainer for details on optimisations you need to consider.
 */
export function useHeroImage(
  deviation: PapiDeviation | undefined,
  width: number,
  height: number
) {
  if (!deviation) {
    return { hero: undefined };
  }

  const hero = DeviationMediaService.getSmallestThumbThatFullyCovers(
    deviation,
    width,
    height,
    // fallback to preview of largest
    t => t.find(i => i.type === 'preview') ?? t[t.length - 1],
    { allowFullview: true, allowPreview: true }
  );

  return { hero };
}
